module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 342
// module chunks = 7